import { WidgetName } from '@wix/bookings-calendar-catalog-viewer-mapper';
import { Preset } from '../types/types';

export const isCalendarPage = (preset: Preset) =>
  preset === Preset.CALENDAR_PAGE;

export const isWeeklyTimeTableWidget = (preset: Preset) =>
  preset === Preset.WEEKLY_TIMETABLE_WIDGET;

export const isCalendarWidget = (preset: Preset) =>
  preset === Preset.CALENDAR_WIDGET;

export const isDailyAgendaWidget = (preset: Preset) =>
  preset === Preset.DAILY_AGENDA_WIDGET;

export const mapPresetToWidgetName = (preset: Preset): WidgetName => {
  switch (preset) {
    case Preset.CALENDAR_PAGE:
      return WidgetName.CALENDAR_PAGE;
    case Preset.CALENDAR_WIDGET:
      return WidgetName.CALENDAR_WIDGET;
    case Preset.WEEKLY_TIMETABLE_WIDGET:
      return WidgetName.WEEKLY_TIMETABLE;
    case Preset.DAILY_AGENDA_WIDGET:
      return WidgetName.DAILY_AGENDA;
  }
};
